import type { WithDataTestid } from '@vlabs/uikit/types';

import type { TableCtx } from './renderTableViewCell';

function getTestIdFromTableCtx<TData extends object, TValue = unknown>(
  ctx: TableCtx<TData, TValue> | undefined,
  getRowId: (row: TData) => string | undefined,
): WithDataTestid | undefined {
  if (!ctx) {
    return undefined;
  }

  return {
    'data-testid': 'row' in ctx
      ? `${ctx.column.id}.cell.${getRowId(ctx.row.original) ?? ctx.row.id}`
      : `${ctx.column.id}.header`,
  };
}

export type { TableCtx };
export { getTestIdFromTableCtx };
